import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

// define your styles
const useStyles = CreateResponsiveStyle({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2c3e50",
  },
contentBoxWrapper:{
  width: "95%",
  height: "auto",
  borderRadius: 15,
  backgroundColor: "#ffffff",
  borderStyle: "solid",
  borderWidth: 1,
  borderColor: "#d1d1d1",
  margin: 25,
},
contentBox:{
  width: "100%",
  borderRadius: 20,
  justifyContent: "center",
  backgroundColor: "red",
},
  radioWidget: {
    paddingTop: 4,
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  contentWrapper: {
    width: "100%",
    height: "100%",
  },
  checkBoxViewStyle: { marginTop: "10%" },
  contentViewStyle: {
    flexDirection: "row",
    marginHorizontal: 30
  },
  headerViewStyle: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
  },
  verticalLineStyle: {
    width: 0.5,
    height: "100%",
    backgroundColor: "#a0a0a0",
  },
  dataViewStyle: {
    flexDirection: "row",
  },
  textInputStyle: {
    width: 290,
    height: 90,
    borderRadius: 9,
    backgroundColor: "#ffffff",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#b9b9b9",
  },

  rcUploadWidget: {},
  rcText: {
    color: "#5f5f5f",
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 600,
    marginVertical: 10,
  },
  RCUpdate_UploadImageContainer: {
    flexDirection: "row",
    height: 90,
    marginTop: 20,
  },
  RCUpdate_ImageUploader: {
    border: "1.5px dashed #ccd0d5",
    borderRadius: 10,
    height: 135,
    width: 135,
    marginRight: 15,
    backgroundColor: "#ffffff",
    marginLeft:10
  },
  RCUpdate_ImageUploader_InnerContainer: {
    width: "100%",
    height: "100%",
    justifyContent: "space-evenly",
    alignItems: "center",
    textAlign: "center",
    paddingBottom: 10,
  },
  RCUpdate_ImageUploader_PlusIcon: {
    fontSize: 35,
    color: "#02122c",
    opacity: "47%",
  },

  RCUpdate_ImageUploader_AddText: {
    fontSize: 11,
    fontFamily: "Inter",
    color: "#02122c",
    opacity: "47%",
  },

  fileSizeText: {
    color: "#757575",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 300,
    marginBottom: 10,
  },
  addImageWidget: {
    alignItems: "center",
  },
  addIcon: {
    fontSize: 20,
    color: "#ccd0d5",
  },
  addText: {
    color: "#02122c",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    opacity: 0.5,
  },
  fileName: {
    color: "#02122c",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    opacity: 0.5,
    width: 100,
    overflow: "hidden",
  },
  addBackImage: {
    marginLeft: 50,
  },
  closeIconLink: {
    position: "absolute",
    top: -12,
    right: -20,
    zIndex: 9,
  },
  closeIcon: {
    width: 89,
    height: 89,
  },
  previewImageView: {
    height: 120,
    width: 120,
  },
  imageStyle: {
    width: 135,
    height: 135,
    fontSize: "1rem",
    color: "white",
    backgroundColor: "#fff",
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: "dashed",
    borderColor: "#ccd0d5",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
  },
  overlayContentStyle: {
    width: "80%",
    height: "95%",
    backgroundColor: "white",
    borderRadius: 15,
    alignSelf: "center",
    justifyContent: "center",
    marginVertical: 10,
  },
  pdfViewStyle: {
    height: "60%",
    width: "100%",
  },
}, {
  [DEVICE_SIZES.XS]: {
    contentViewStyle: {
      flexDirection: "column"
    },
    checkBoxViewStyle: { marginTop: "40%" },
  }
});

//make this component available to the app
export default useStyles;
